export const CHECKOUT_URL = 'https://artepronta.impultienda.ar/checkout'
